module.exports = __webpack_public_path__ + "img/due-7-days.5b3f1409.svg";